var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"el"},[_c('p',[_vm._v(_vm._s(_vm.$t('action_plan.nodes.terminate.name')))])])}
var staticRenderFns = []

export { render, staticRenderFns }